import styled from 'styled-components';
import Chat from './Chat';

export default styled(Chat)`
  .chat {
    display: flex;
  }
`;
